module.exports = __webpack_public_path__ + "components/advertise-markets/static/ad-mobile-56a97e81cf1643005050401e6a67d14e.jpg";